import 'jquery-ui/ui/widgets/sortable.js';

const sortableWarningMessage = "Unable to initialize sortable table, jQuery UI sortable plugin is not loaded.";
const sortableRetryLimit = 12;
const sortableRetryDelay = 150;

const getSortableContext = function() {
    const candidates = [window.jQuery, window.$];
    for (let i = 0; i < candidates.length; i++) {
        const candidate = candidates[i];
        if (candidate && candidate.fn && typeof candidate.fn.sortable === "function") {
            return candidate;
        }
    }

    return null;
};

const initializeSortableForTable = function(id, table, attempt = 0) {
    if (typeof table.sortable === "undefined") {
        return;
    }

    const sortableJquery = getSortableContext();
    if (sortableJquery !== null) {
        sortableJquery("table#" + id + " tbody").sortable({
            handle: ".sortable",
            update: function() {
                let _token = sortableJquery("input[name=_token]").val();
                let data = sortableJquery("table#" + id + " tbody i.sortable").map(function() {
                    return sortableJquery(this).attr("data-id");
                }).get();

                $.ajax({
                    data: {
                        _token: _token,
                        data: data
                    },
                    type: "POST",
                    url: table.sortable.url
                });
            }
        });

        return;
    }

    if (attempt >= sortableRetryLimit) {
        if (typeof console !== "undefined") {
            console.error(sortableWarningMessage);
        }

        return;
    }

    window.setTimeout(function() {
        initializeSortableForTable(id, table, attempt + 1);
    }, sortableRetryDelay);
};

window.initBootstrapTable = function(id, table, refresh) {
    let bootstrapTableLocale = window.locale_3 || window.locale || "en-US";

    if (refresh) {
        $("#"+id).bootstrapTable("destroy");
    }
    $("#"+id).bootstrapTable({
        url: table.url,
        locale: bootstrapTableLocale,
        iconsPrefix: " ", // must be empty, default is "bi", and "bi far fa-sync" does not work.
        icons: {
            paginationSwitchDown: 'far fa-angle-down',
            paginationSwitchUp: 'far fa-angle-up',
            refresh: 'far fa-sync',
            toggleOff: 'far fa-toggle-off',
            toggleOn: 'far fa-toggle-on',
            columns: 'far fa-columns',
            detailOpen: 'far fa-lg fa-plus-square',
            detailClose: 'far fa-lg fa-minus-square',
            clearSearch: 'far fa-times',
        },
        paginationPreText: '<span class="fal fa-chevron-left"></span>',
        paginationNextText: '<span class="fal fa-chevron-right"></span',
        queryParams: function(params) {
            let r = {
                limit: params.limit,
                offset: params.offset,
                order: params.order,
                search: params.search,
                sort: params.sort
            };
            if (typeof table.ts === "undefined") {
                r.ts = new Date().getTime();
            }
            if (typeof table.filters !== "undefined") {
                let filters = {};
                $.each(table.filters, function(index, filter) {
                    let f = $("#" + filter);
                    if (typeof f.attr("multiple") !== "undefined" && f.attr("multiple") !== false) {
                        let multiple = [];
                        $("#" + filter + " :selected").each(function(index2, selected) {
                            let val = $(selected).val();
                            multiple.push(val);
                        });
                        filters[filter] = JSON.stringify(multiple);
                    } else {
                        filters[filter] = f.val();
                    }
                });
                r = $.extend({}, r, filters);
            }
            return r;
        },
        onPostBody: function () {
            if (typeof table.search_input_focus !== typeof undefined) {
                $(".search-input").focus();
            }
        },
        onLoadSuccess: function() {
            if (typeof table.callback !== typeof undefined) {
                let fn = window[table.callback];
                if (typeof fn === "function") {
                    fn();
                }
            }
        }
    });
    if (typeof table.sortable != "undefined") {
        initializeSortableForTable(id, table, 0);
    }
}

window.initBootstrapTables = function() {
    if (typeof tables == "undefined") {
        return false;
    }
    $.each(tables, function(id, table) {
        initBootstrapTable(id, table, false);
    });
}

window.loadingTemplate = function() {
    return '<div class="loading-template"><i class="fa-solid fa-spinner fa-spin-pulse fa-spin-reverse"></i></div>';
};

window.refreshBootstrapTable = function(id) {
    let table = tables[id];
    initBootstrapTable(id, table, true);
}
